<script>
  import { onMount } from "svelte";
  import LandingHeader from "../components/LandingHeader.svelte";
  import ProtectedRoute from "../components/ProtectedRoute.svelte";

  let subscriptions = [];
  let alternateNames = [];
  let errorMessage = "";
  let userData = null;
  let showConfirmationModal = false;
  let subscriptionToRemove = null;
  let subscriptionNameToRemove = ""; // Store the name of the subscription

  onMount(() => {
    userData = JSON.parse(localStorage.getItem("userData"));
  });

  onMount(async () => {
    try {
      const response = await fetch(
        `https://api.trulens.ae/api/subscribe/subscriptions?_=${Date.now()}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: userData.token,
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || "Failed to fetch subscriptions");
      }

      const data = await response.json();

      // Ensure correct assignment of subscriptions
      subscriptions = data.userSubscriptions || [];
      alternateNames = (data.alternateNameSubscriptions || []).map(
        (altSub) => altSub.alternateName // Extract the alternateName field
      );
    } catch (error) {
      // console.error("Error fetching subscriptions:", error);
      errorMessage = error.message;
    }
  });

  async function removeSubscription() {
    try {
      const endpoint = subscriptionToRemove
        ? `https://api.trulens.ae/api/subscribe/remove?_=${Date.now()}`
        : `https://api.trulens.ae/api/subscribe/remove-alias?_=${Date.now()}`;

      const body = subscriptionToRemove
        ? { subscribedToId: subscriptionToRemove }
        : { alternateName: subscriptionNameToRemove };

      const response = await fetch(endpoint, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: userData.token,
        },
        body: JSON.stringify(body),
      });

      if (response.ok) {
        if (subscriptionToRemove) {
          subscriptions = subscriptions.filter(
            (subscription) => subscription._id !== subscriptionToRemove
          );
        } else {
          alternateNames = alternateNames.filter(
            (altName) => altName !== subscriptionNameToRemove
          );
        }
        showConfirmationModal = false; // Close the modal
      } else {
        const errorData = await response.json();
        // console.error(
        //   "Failed to unsubscribe:",
        //   errorData.message || response.statusText
        // );
      }
    } catch (error) {
      // console.error("Error unsubscribing:", error);
    }
  }

  function confirmRemoval(subscriptionId, subscriptionName) {
    subscriptionToRemove = subscriptionId;
    subscriptionNameToRemove = subscriptionName; // Set the subscription name
    showConfirmationModal = true;
  }
</script>

<ProtectedRoute>
  <main>
    <LandingHeader />
    <div class="title">
      <span class="title-span">Subscriptions</span>
    </div>

    {#if errorMessage}
      <p class="error">{errorMessage}</p>
    {/if}

    <div class="subscriptions">
      {#if subscriptions.length > 0 || alternateNames.length > 0}
        <table class="subscription-table">
          <thead>
            <tr>
              <th>Subscriptions</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {#each subscriptions as subscription}
              <tr class="subscription-row">
                <td class="profile-cell">
                  <img
                    class="profile-picture"
                    src={subscription.profilePicture || "/profile.png"}
                    alt={`${subscription.name}'s profile picture`}
                  />
                  <span class="username">{subscription.name}</span>
                </td>
                <td>
                  <button
                    class="remove-button"
                    on:click={() =>
                      confirmRemoval(subscription._id, subscription.name)}
                  >
                    Unsubscribe
                  </button>
                </td>
              </tr>
            {/each}

            {#each alternateNames as altName}
              <tr class="subscription-row">
                <td class="profile-cell">
                  <img
                    class="profile-picture"
                    src="/anonymous.jpg"
                    alt={`${altName}'s profile picture`}
                  />
                  <span class="username">{altName}</span>
                </td>
                <td>
                  <button
                    class="remove-button"
                    on:click={() => confirmRemoval(null, altName)}
                  >
                    Unsubscribe
                  </button>
                </td>
              </tr>
            {/each}
          </tbody>
        </table>
      {:else}
        <p>No subscriptions found.</p>
      {/if}
    </div>

    {#if showConfirmationModal}
      <div class="modal">
        <div class="modal-content">
          <p>
            Are you sure you want to remove the subscription to <strong
              >{subscriptionNameToRemove}</strong
            >?
          </p>
          <div class="modal-actions">
            <button
              class="cancel-button"
              on:click={() => (showConfirmationModal = false)}
            >
              No
            </button>
            <button class="confirm-button" on:click={removeSubscription}>
              Yes
            </button>
          </div>
        </div>
      </div>
    {/if}
  </main>
</ProtectedRoute>

<style>
  .title {
    position: relative;
    display: flex;
    justify-content: center;
    padding: 10px;
    box-shadow: 0 4px 8px rgba(135, 135, 135, 0.1);
    /* background: linear-gradient(to bottom, #FF3C82 45%, #1e92ff 55%); */
    /* background: linear-gradient(130deg, #cdb4db, #ffffff);
      box-shadow:
        inset -20px 0 50px #cdb4db,
        inset 20px 0 50px #cdb4db; */
  }

  .title-span {
    margin-top: 5px;
    /* border: 2px solid #000000; */
    border-radius: 25%;
    /* margin: 0 15px; */
    padding: 5px;
    font-size: 1.2rem;
    color: #000000;
    /* text-decoration: underline; */
    /* cursor: pointer; */
    font-size: 1.4rem;
    font-weight: bold;
  }

  .subscriptions {
    display: flex;
    justify-content: center;
    margin-top: 2rem;
  }

  .subscription-table {
    width: 65%;
    border-collapse: collapse;
    text-align: left;
  }

  .subscription-table th,
  .subscription-table td {
    padding: 1rem;
    border: 1px solid #ddd;
  }

  .subscription-row {
    vertical-align: middle;
  }

  .profile-cell {
    display: flex;
    align-items: center;
    gap: 1rem;
  }

  .profile-picture {
    width: 50px;
    height: 50px;
    object-fit: cover;
    border-radius: 50%;
  }

  .username {
    font-size: 1rem;
    font-weight: bold;
  }

  .remove-button {
    background-color: #ff4d4f;
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 4px;
    cursor: pointer;
  }

  .remove-button:hover {
    background-color: #ff7875;
  }

  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .modal-content {
    background: white;
    padding: 2rem;
    border-radius: 8px;
    text-align: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
  }

  .modal-actions {
    display: flex;
    justify-content: space-around;
    margin-top: 1rem;
  }

  .cancel-button,
  .confirm-button {
    padding: 0.5rem 1rem;
    border: none;
    border-radius: 4px;
    cursor: pointer;
  }

  .cancel-button {
    background-color: #ddd;
    color: black;
  }

  .cancel-button:hover {
    background-color: #bbb;
  }

  .confirm-button {
    background-color: #ff4d4f;
    color: white;
  }

  .confirm-button:hover {
    background-color: #ff7875;
  }

  .error {
    color: red;
    margin-top: 0.5rem;
    text-align: center;
  }

  @media (max-width: 768px) {
    .title {
      padding: 10px 20px;
    }

    .title-span {
      font-size: 1.2rem;
    }

    .profile-picture {
      width: 30px;
      height: 30px;
    }

    .username {
      font-size: 0.8rem;
    }

    .remove-button {
      font-size: 0.7rem;
      padding: 0.3rem 0.6rem;
    }

    .subscription-table th,
    .subscription-table td {
      padding: 0.5rem;
    }

    .modal-content {
      padding: 1rem;
    }

    .cancel-button,
    .confirm-button {
      padding: 0.4rem 0.8rem;
    }

    .modal-content {
      width: 85%;
      max-width: 350px;
    }

    .subscription-table {
      width: 75%;
    }
  }

  @media screen and (min-width: 768px) {
    .title {
      margin-top: 40px;
    }
  }

  @media screen and (min-width: 850px) {
    .title {
      margin-top: 5px;
    }
  }

  @media screen and (min-width: 850px) and (min-height: 1280px) {
    .title {
      margin-top: 55px;
    }
  }

  @media screen and (min-width: 1024px) and (max-width: 1024px) and (max-height: 600px) {
    .title {
      margin-top: 5px;
    }
  }

  @media screen and (min-width: 1024px) and (min-height: 1300px) {
    .title {
      margin-top: 60px;
    }
  }

  @media screen and (min-width: 1440px) {
    .title {
      margin-top: 20px;
    }
  }
</style>
